import { z } from "zod";

/** Registro DNS tal como lo expone la API de Cloudflare (campos usados por la UI/API). */
export interface IDnsRecord {
  id: string;
  /** En listados algunas respuestas omiten este campo; Cloudflare lo incluye en otros contextos. */
  zone_id?: string;
  zone_name?: string;
  name: string;
  type: string;
  content: string;
  proxiable?: boolean;
  proxied?: boolean;
  ttl: number;
  locked?: boolean;
  priority?: number;
  comment?: string | null;
  created_on?: string;
  modified_on?: string;
}

export interface IDnsRecordListMeta {
  page: number;
  per_page: number;
  count: number;
  total_count: number;
}

export interface IDnsRecordListResult {
  records: IDnsRecord[];
  meta: IDnsRecordListMeta;
}

export interface ICloudflareZone {
  id: string;
  name: string;
  status: string;
}

export const dnsRecordSchema = z.object({
  id: z.string(),
  zone_id: z.string().optional(),
  zone_name: z.string().optional(),
  name: z.string(),
  type: z.string(),
  content: z.string(),
  proxiable: z.boolean().optional(),
  proxied: z.boolean().optional(),
  ttl: z.coerce.number(),
  locked: z.boolean().optional(),
  priority: z.number().optional(),
  comment: z.string().nullable().optional(),
  created_on: z.string().optional(),
  modified_on: z.string().optional(),
});

export const dnsRecordListMetaSchema = z.object({
  page: z.number(),
  per_page: z.number(),
  count: z.number(),
  total_count: z.number(),
});

export const dnsRecordListResultSchema = z.object({
  records: z.array(dnsRecordSchema),
  meta: dnsRecordListMetaSchema,
});

export const cloudflareZoneSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: z.string(),
});

/** Zona por defecto desde env (GET /api/v1/dns/zone). */
export const dnsConfiguredZoneSchema = z.object({
  id: z.string(),
  name: z.string().optional(),
});

export const dnsEditFormSchema = z.object({
  name: z.string().min(1),
  type: z.string().min(1),
  content: z.string().min(1),
  ttl: z.coerce.number().int().min(60),
  proxied: z.boolean().optional(),
  comment: z.string().optional(),
});

export type DnsEditFormInput = z.input<typeof dnsEditFormSchema>;
export type DnsEditFormValues = z.infer<typeof dnsEditFormSchema>;
